import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { colors } from 'style/config';
import { Flex, Image, Text } from 'components/ui';
import Chevron from 'components/Chevron/Chevron';

const GiftCardExpandButton = React.forwardRef((props, ref) => {
    return (
        <Flex
            ref={ref}
            alignItems='center'
            justifyContent={['space-between', !props.isEditMode ? 'left' : 'space-between']}
            gap={['6px', '6px', 4]}
            {...(!props.isEditMode
                ? {
                    paddingX: [4, 5],
                    paddingTop: 4
                }
                : {
                    paddingX: 3,
                    paddingY: 4
                })}
            borderColor='midGray'
            css={[styles.giftCardBox, props.isEditMode && styles.withBorder]}
            width={['100%', !props.isEditMode ? 'auto' : '100%']}
            onClick={props.onClick}
        >
            <Flex
                gap={2}
                alignItems='center'
            >
                <Image
                    src='/img/ufe/payments/giftCardBordered.svg'
                    display='block'
                    width={25}
                    height={16}
                />
                <Text
                    children={props.useGiftCard}
                    color='blue'
                />
            </Flex>
            {props.isEditMode && (
                <Chevron
                    direction='down'
                    color='#888888'
                    css={styles.chevron}
                />
            )}
        </Flex>
    );
});

const styles = {
    giftCardBox: {
        ':hover': { borderColor: colors.black }
    },
    chevron: {
        width: '16px',
        height: '16px'
    },
    withBorder: {
        border: '1px solid',
        borderRadius: 2,
        borderColor: colors.midGray
    }
};

export default wrapFunctionalComponent(GiftCardExpandButton, 'GiftCardExpandButton');
